import CustomPreloader from '@components/CustomPreloader'

import './suspenseFallback.scss'

const SuspenseFallback = () => (
  <div className='suspense-fallback-wrapper' aria-live='polite' aria-busy='true'>
    <CustomPreloader />
  </div>
)

export default SuspenseFallback
